import { create } from 'zustand';

export type SuperlikeSessionStore = {
  answeredSenderIds: ReadonlySet<string>;
  rememberAnsweredSender: (senderId: string) => void;
};

export const useSuperlikeSessionStore = create<SuperlikeSessionStore>()(
  (set) => ({
    answeredSenderIds: new Set<string>(),
    rememberAnsweredSender: (senderId) =>
      set(({ answeredSenderIds }) =>
        answeredSenderIds.has(senderId)
          ? {}
          : { answeredSenderIds: new Set([...answeredSenderIds, senderId]) },
      ),
  }),
);

export const withoutAnsweredSenders = <T extends { id: string }>(
  cards: T[],
  answeredSenderIds: ReadonlySet<string>,
) => cards.filter((card) => !answeredSenderIds.has(card.id));
